<template>
  <div
    v-if="item.category && item.displayCategory"
    class="card"
  >
    <div class="card-content">
      <div
        class="d-flex flex-column align-center"
        style="gap:10px;"
      >
        <bank-icon
          :bank="title"
          :logo-url="logoUrl"
        />

        <div
          class="d-flex flex-row align-center"
          style="width:100%;"
        >
          <div class="card-content-risk-factor">
            {{ riskScore }}
          </div>
          <div class="card-content-risk-category">
            <span class="risk-category-first-word">{{ displayCategoryFirstWord }}</span> {{ displayCategoryRest }}
          </div>
        </div>
      </div>

      <div style="width: 152px; height: 152px;">
        <v-lazy
          :options="{threshold: .5}"
          transition="fade-transition"
        >
          <base-e-chart-pie
            :chart-data-options="chartDataOptions"
            :chart-height="152"
            :tooltip-show="false"
            chart-animation-easing="elasticOut"
            tooltip-confine
            :label-line-show="false"
            :label-show="false"
            :legend-show="false"
            :emphasis-disabled="true"
            style="pointer-events: none;"
            :pie-border-width="0"
            :pie-border-radius="0"
            :pie-shadow-blur="10"
            :pie-shadow-color="'rgba(61, 104, 213, 0.24)'"
            :start-angle="70"
            :outer-border="{
              minRadius: '87%',
              maxRadius: '92%',
              color: 'white'
            }"
          />
        </v-lazy>
      </div>
    </div>
  </div>
</template>

<script>

import BaseEChartPie from '@/theme/default/components/charts/echarts/BaseEChartPie'
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'
import BankIcon from '@/theme/default/components/common/icons/BankIcon'

export default {
  name      : 'LiquidityRiskAssessmentCard',
  components: {
    BaseEChartPie,
    BankIcon
  },
  mixins: [chartsColorMixin],
  props : {
    item: {
      type   : Object,
      default: () => {}
    },
    title: {
      type   : String,
      default: ''
    },
    logoUrl: {
      type   : String,
      default: ''
    }
  },
  computed: {
    category () {
      return this.item.category ?? ''
    },
    displayCategory () {
      return this.item.displayCategory ?? ''
    },
    riskScore () {
      return this.item.riskScore + '/10' ?? ''
    },
    riskScoreColors () {
      return this.item.riskScoreColors ?? ''
    },
    displayCategoryFirstWord () {
      return this.displayCategory.split(' ')[0] ?? ''
    },
    displayCategoryRest () {
      return this.displayCategory.split(' ').slice(1).join(' ') ?? ''
    },
    chartColors () {
      return {
        high: {
          primary  : this.themeColorRGBA('synthesis-ui-red-01'),
          secondary: this.themeColorRGBA('synthesis-ui-red-08')
        },
        medium: {
          primary  : this.themeColorRGBA('synthesis-ui-yellow-01'),
          secondary: this.themeColorRGBA('synthesis-ui-yellow-08')
        },
        low: {
          primary  : this.themeColorRGBA('synthesis-ui-green-01'),
          secondary: this.themeColorRGBA('synthesis-ui-green-08')
        }
      }
    },
    chartDataOptions () {
      const riskScore = Math.max(0, Math.min(10, this.item.riskScore || 0))
      const remainingScore = 10 - riskScore

      return [
        {
          name     : this.$t('RiskLiquidity.Section.LiquidityRiskAssessment.RiskScore'),
          value    : riskScore,
          type     : 'percent',
          radius   : ['48%', '82%'],
          itemStyle: {
            color: this.getChartColorBasedOnRiskScore()?.primary
          }
        },
        {
          name     : '',
          value    : remainingScore,
          type     : 'percent',
          itemStyle: {
            color: this.getChartColorBasedOnRiskScore()?.secondary
          }
        }

      ]
    }
  },
  methods: {
    getChartColorBasedOnRiskScore () {
      if (this.item?.category === 'High') {
        return this.chartColors.high
      } else if (this.item?.category === 'Medium') {
        return this.chartColors.medium
      } else {
        return this.chartColors.low
      }
    }
  }
}
  </script>

<style scoped>

.card {
    background-color: var(--v-synthesis-ui-grey-06-base);
    border-radius: 8px;
    padding: 7px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 214px;
}

.card-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    gap:20px;
}

.card-content-risk-factor {
    background-color: white;
    box-shadow: 0px 4px 16px 0px #3D68D552;
    border-radius: 8px;
    text-align: center;
    padding:6px 10px;
    font-weight:700;
    font-size:20px;
    color: var(--v-synthesis-ui-grey-01-base);
}

.card-content-risk-category {
    padding:10px;
    color: var(--v-synthesis-ui-grey-01-base);
}

.risk-category-first-word {
    font-weight: 700;
}

</style>
